module.exports = __webpack_public_path__ + "img/pos3.29a90272.webp";